import { getRequiredMessage } from 'views/declarations/utils/validation-utils';
import * as Yup from 'yup';

export const getCreateTemplateValidationSchema = (templateNames?: Set<string>) => {
    return Yup.object().shape({
        country: Yup.string().required(getRequiredMessage('field')).nullable(),
        declarationType: Yup.string().required(getRequiredMessage('field')).nullable(),
        formType: Yup.string().required(getRequiredMessage('field')).nullable(),
        name: Yup.string()
            .required(getRequiredMessage('field'))
            .nullable()
            .test({
                name: 'unique-name',
                message: 'This name already exists',
                test: (value) => {
                    if (value == null) return true;
                    return !templateNames?.has(value);
                },
            }),
        teamId: Yup.string().nullable(),
    });
};
